import { Injectable,OnInit,OnDestroy } from '@angular/core'
import { CACHE_CONSTANT, CacheService } from "./cacheService.service";
import { Subscription } from 'rxjs';
import { AppSettings } from '../../interfaces/setting.interface';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalState } from 'src/app/global.state';


@Injectable()
export class AuthService implements OnInit, OnDestroy {
    cache_constant: CACHE_CONSTANT = <CACHE_CONSTANT>{};
    private _subscriptions: Array<Subscription> = [];
    constructor(private cacheService: CacheService, private httpClient: HttpClient, private state: GlobalState) {
    }
    ngOnInit() {

    }

    public get apiUrl(): string {
        let url = this.state.getGlobalSetting("apiUrl");
        let apiUrl = "";

        if (!!url && url.length > 0) { apiUrl = url[0] };
        //console.log({ apiUrl: apiUrl })
        return apiUrl
    }

    changePassword(oldPassword: string, newPassword: string) {
        const options = { headers: this.getRequestOption(), };
        return this.httpClient.post<any>(this.apiUrl + `/ChangePassword`, { oldPassword, newPassword },);
    }

    isAuthorized(routeInstruction: any) {
        let profile = this.getUserProfile();
        return this.isAuthenticated(profile);
    }
    removeAuth(): void {
        this.cacheService.removeAll()
        
    }
    isAuthenticated(profile: any) {
        return !!profile;
    }
    setAuth(auth: any) {
        this.cacheService.set('USER_PROFILE', auth.profile);
        this.cacheService.set('TOKEN', auth.token);
        this.cacheService.set('setting',auth.setting);
        this.cacheService.set('role',auth.role);
        console.log("Token", this.cacheService.get('TOKEN'));
        //this.setting.appSetting.setSetting(auth.setting);
    }
    getAuth(): any {
        let auth: any = {
            profile: this.cacheService.get('USER_PROFILE'),
            token: this.cacheService.get('TOKEN'),
            
        };
        //console.log({gettoken:auth.token});
        return auth;
    }
    get getRole(): any{
        return this.cacheService.get('role');
    }
    getUserProfile(): any {
        if (!this.cacheService.exist('USER_PROFILE')) {
            return null;
        }
        let userProfile = this.cacheService.get('USER_PROFILE');
        return userProfile;
    }

    checkUserRight(right:string){
        let user_profile:any=this.getUserProfile();
        let user_rights:any;
        var result: any[];
        if(user_profile){
            user_rights = user_profile.userRights;
            if(user_rights){
                result =user_rights[right]
            }
        }
        return result;
    }
public canActive:boolean=false;
    checkMenuRight(menu:string, right:string){
        let user_profile:any=this.getUserProfile();
        let menu_rights:any[] = [];
        var result=false;
        if(user_profile){
            menu_rights = user_profile.menuRights;
            if(menu_rights){
                for(var m in menu_rights){
                   if(menu_rights[m].menu == menu){
                       for(var r in menu_rights[m].right){
                           if(menu_rights[m].right[r] == right){
                               this.canActive=result;
                              result = true;
                           }
                       }
                   }
                }
            }
        }
        return result;
    }

    getSetting():AppSettings{
        if(!this.cacheService.exist('setting')){
            return undefined;
        }
        let setting = <AppSettings>this.cacheService.get('setting');
        return setting;
    }

    getRequestOption() {
        let headers: HttpHeaders = new HttpHeaders({ 'Content-type': 'application/json', 'Authorization': this.getAuth().token })
        console.log({ headers: headers });
        return { headers: headers };
    }
    ngOnDestroy(){
        this._subscriptions.forEach(sub => {
            sub.unsubscribe();
        });
    }
}